// extracted by mini-css-extract-plugin
export default {"label":"Textarea_label__LgPn6","textarea":"Textarea_textarea__n+Bog","isInvalid":"Textarea_isInvalid__0SKVV"};